import React from 'react';
import { cx } from './utils';

export default function TextField({
  label,
  hint,
  error,
  className,
  inputClassName,
  ...props
}) {
  const describedBy = [hint ? `${props.id || props.name}-hint` : null, error ? `${props.id || props.name}-error` : null]
    .filter(Boolean)
    .join(' ');

  return (
    <label className={cx('field', className)}>
      {label && <span className="field__label">{label}</span>}
      <input
        className={cx('input', error && 'input--error', inputClassName)}
        aria-invalid={Boolean(error) || undefined}
        aria-describedby={describedBy || undefined}
        {...props}
      />
      {hint && (
        <span id={`${props.id || props.name}-hint`} className="field__hint">
          {hint}
        </span>
      )}
      {error && (
        <span id={`${props.id || props.name}-error`} className="field__error">
          {error}
        </span>
      )}
    </label>
  );
}
